import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import RegisterPage from './components/RegisterPage';
import QRRegistrationPage from './components/QRRegistrationPage';
import LoginPage from './components/LoginPage';
import QRLoginPage from './components/QRLoginPage';
import NewLoginPage from './components/NewLoginPage';
import Dashboard from './components/Dashboard';
import SettingsPage from './components/SettingsPage';

function AppContent() {
  
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('isLoggedIn'));
  const [isFirstLogin, setIsFirstLogin] = useState(false);

  const [userEmail, setUserEmail] = useState('');
  const navigate = useNavigate();


  const handleLogin = (userData) => {
    setIsAuthenticated(true);
    setUserEmail(userData.email);
    localStorage.setItem('isLoggedIn', 'true');
    setIsFirstLogin(true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUserEmail('');
    localStorage.removeItem('isLoggedIn');
    navigate('/');
  };

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={isAuthenticated ?
            <Dashboard userEmail={userEmail} onLogout={handleLogout} isFirstLogin={isFirstLogin} /> : <LandingPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/qr-registration" element={<QRRegistrationPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route
          path="/login"
          element={
            isAuthenticated ?
            <Navigate to="/dashboard" /> :
            <LoginPage onLogin={handleLogin} />
          }
        />
        <Route
          path="/qr-login"
          element={
            isAuthenticated ?
            <Navigate to="/dashboard" /> :
            <QRLoginPage onLogin={handleLogin} />
          }
        />
        <Route
          path="/new-login"
          element={
            isAuthenticated ?
            <Navigate to="/dashboard" /> :
            <NewLoginPage onLogin={handleLogin} />
          }
        />
        <Route
          path="/dashboard"
          element={
            isAuthenticated ?
            <Dashboard userEmail={userEmail} onLogout={handleLogout} isFirstLogin={isFirstLogin} /> :
            <Navigate to="/login" />
          }
        />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;

